import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrinterService {
  private urlPrinter: string;
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  public getCupsPrinters(): Observable<any> {
    this.urlPrinter = this.config.getBackendResource('printer');
    return this.http.get<any>(`${this.urlPrinter}`);
  }
}
